import React, { useEffect, useState, useCallback } from 'react';
import './index.scss';
import ModalBox from '../../components/ModalBox';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import { Row } from 'react-materialize';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';
import ImageViewer from 'react-simple-image-viewer';
import { allNotifications } from '../../utils/toastify';
import { ToastContainer } from 'react-toastify';
import services from '../../services/services';
import PdfIcon from '../../image/pdf.svg';
import { toCurrencyString } from '../../utils/currencyFormat';

const { notifyErrorBottomRight } = allNotifications;

const GtoDetailsConcluded = props => {
  const [procedures, setProcedures] = useState([]);
  const [gtoInfo, setGtoInfo] = useState([]);
  const [infoProcedures, setInfoProcedures] = useState({gto_assinada: [{nome_arquivo: '', url: ''}]});
  const [observacoes, setObservacoes] = useState('');
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [gtoImage, setGtoImage] = useState([]);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [modalActive, setModalActive] = useState(true);

  const { gtoId, codigoPrestador, dataPagamento } = props.location.state;

  useEffect(() => {
    async function fetchData() {
      const resGtoDetails = await services.mobileengine('buscarGtoProcedimentosDetalhes', {codigoPrestador, gtoId}).catch(() => {
        notifyErrorBottomRight('Erro ao buscar informações da GTO');
      });
      setProcedures(resGtoDetails.gto_det_models.filter(p => !p.flag_recurso));
      setGtoInfo(resGtoDetails.gto_totais);
      setObservacoes(resGtoDetails.gto_det_models[0].observacoes);

      const infoProcedimento = await services
        .mobileengine('buscarInfoProcedimentos', {
          codigoPrestador,
          gtoId
        })
        .catch(() => {
          notifyErrorBottomRight('Erro ao buscar informações da GTO');
        });
      if (infoProcedimento) {
        setInfoProcedures(infoProcedimento);
        if (infoProcedimento.gto_assinada) {
            infoProcedimento.gto_assinada.map(gto => {
              setGtoImage([...gtoImage, gto.url]);
            })
        }
      }
    }
    fetchData();
  }, [setProcedures, setInfoProcedures]);

  const openImageViewer = useCallback(index => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const toggleCreate = () => {
    setModalActive(false);
    props.history.goBack();
  };

  const openInfoProcedures = procedure => {
    const infoProcedure = infoProcedures.procedimentos.find(
      proc => proc.id_procedimento === procedure.cod_interno
    );
    const dataRealizacao = infoProcedure.data_realizacao;
    const { imagens } = infoProcedure;

    props.history.push({
      pathname: '/faturar-procedimento',
      state: { procedure, dataRealizacao, imagens, isDetails: true }
    });
  };

  const handlePdfLink = () => {
    setPdfLoading(true);

    services
      .procedimento('getPDFGTO', { gtoId })
      .then(res => {
        const byteCharacters = atob(res.data.pdfObject);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const file = new Blob([byteArray], { type: 'application/pdf' });
        const pdfURL = URL.createObjectURL(file);

        window.open(pdfURL);
      })
      .catch(err => {
        notifyErrorBottomRight(err.message);
      })
      .finally(() => {
        setPdfLoading(false);
      });
  };

  const pagamentoEfetuado = dataPagamento =>
    new Date(`${dataPagamento.split('/')[2]}-${dataPagamento.split('/')[1]}-${dataPagamento.split('/')[0]} 00:00`) <= new Date();

  return (
    <ModalBox
      modalActive={modalActive}
      modalLabel="Realizadas"
      onChange={toggleCreate}
      style={{ padding: 15 }}
    >
      <ToastContainer />
      <Row style={{ marginBottom: 0 }}>
        <div
          className="col s10"
          style={{ fontSize: 20, fontWeight: 600, color: '#1B365D', padding: 0 }}
        >
          {`GTO ${gtoId}`}
        </div>
        <div className="col s2 right-align" style={{ padding: 0, color: '#1B365D' }}>
          {!pdfLoading ? (
            <>
              <span onClick={handlePdfLink} style={{ paddingTop: 2, cursor: 'pointer' }}>
                <GetAppOutlinedIcon fontSize="inherit" />
                {' '}
PDF
</span>
            </>
          ) : (
              <CircularProgress disableShrink style={{ width: 15, height: 15 }} />
            )}
        </div>
      </Row>
      <Row>
        <div className='gto-info'>
          <p>Data de pagamento: {dataPagamento}</p>        
          <p>Data de envio para cobrança: {gtoInfo.data_envio_cobranca}  </p>
          <p>Valor processado: {gtoInfo.data_envio_cobranca === undefined ? '-' : `R$ ${toCurrencyString(gtoInfo.total_valor_processado?.toFixed(2))}`}</p>
          <p>Status da GTO: {gtoInfo.status_protocolo}</p>
          <p>Valor da glosa: {
            pagamentoEfetuado(dataPagamento) && gtoInfo.total_valor_glosa > 0
            ? `R$ ${toCurrencyString(gtoInfo.total_valor_glosa?.toFixed(2))}`
            : '-'}</p>
          <p>Valor liberado: {
            pagamentoEfetuado(dataPagamento) && gtoInfo.total_valor_liberado > 0
            ? `R$ ${toCurrencyString(gtoInfo.total_valor_liberado?.toFixed(2))}`
            : '-'}</p>        
        </div>
      </Row>

      {procedures
        .filter(proc => 
          // !proc.flag_procedimento_excluido &&
          (
            proc.fim_tratamento !== '01/01/0001' ||
            (
              gtoInfo.data_envio_cobranca !== undefined &&
              proc.data_cancelamento >= gtoInfo.data_envio_cobranca &&
              proc.cod_glosa_tiss === 3049
            )
          ))
        .map(procedure => (
          <ExpansionPanel id="gtodetails-panel">
            <ExpansionPanelSummary
              aria-controls="panel1a-content"
              className="panel-header"
              onClick={() => openInfoProcedures(procedure)}
            >
              <div
                className="row"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 0
                }}
              >
                <div className="col s11" style={{ padding: 0 }}>
                  {procedure.data_cancelamento.substring(0, 10) === '01/01/0001' ? "" : (
                    <span className="status-badge excluido">Cancelado com sucesso</span>
                  )}
                  <p className="card-label" style={{ marginTop: 6 }}>
                    <span className="txt-procedure">
                      {`${procedure.cod_proced.trim()} - ${procedure.procedimento}`}
                    </span>
                  </p>
                  <div className="info-procedure" style={{ fontSize: 12, color: '#696969' }}>
                    {procedure.regiao !== '' && Number.isNaN(procedure.regiao) && (
                      <span>{`Região: ${procedure.regiao} | `}</span>
                    )}
                    {procedure.regiao !== '' && !Number.isNaN(procedure.regiao) && (
                      <span>{`Dente: ${procedure.regiao} | `}</span>
                    )}
                    {procedure.face !== '' && <span>{`Face: ${procedure.face} | `}</span>}
                  </div>
                  <p style={{ fontSize: 12, color: '#696969' }}>
                    {`Data da realização: ${procedure.data_cancelamento.substring(0, 10) !== '01/01/0001' ? '-' : procedure.fim_tratamento}`}
                  </p>
                </div>
                <div className="col s1" style={{ padding: 0, textAlign: 'right' }}>
                  <ArrowForwardIosIcon style={{ fontSize: '1rem' }} />
                </div>
              </div>
            </ExpansionPanelSummary>
          </ExpansionPanel>
        ))}
      <div className="info-header noselect">
        <p>
          <span>GTO assinada</span>
        </p>
        {infoProcedures.gto_assinada
            .filter(gto => gto.url !== undefined)
            .map(gto => (
        <div className="attach-images__container">
          <li className="image">
            <div className="box-image">
              <span>
                <div className="attach">
                  <div className={"box--thumbnail" + (gto.url.split('?')[0].endsWith('.pdf') ? '-pdf' : '')}>
                    {!gto.url.split('?')[0].endsWith('.pdf') && (
                    <img
                      crossorigin="anonymous"
                      className="thumbnail"
                      src={gto.url}
                      alt="thumbnail"
                      onClick={() => openImageViewer(0)}
                    />
                    )}
                    {gto.url.split('?')[0].endsWith('.pdf') && (
                    <a href={gto.url} target="_blank">
                      <img
                        crossorigin="anonymous"
                        className="thumbnail"
                        src={PdfIcon}
                        alt="thumbnail"
                      />
                    </a>
                    )}
                  </div>
                </div>
                <span className="nameImage">Imagem GTO</span>
              </span>
            </div>
          </li>
        </div>))}
      </div>
      {isViewerOpen && (
        <ImageViewer src={gtoImage} currentIndex={currentImage} onClose={closeImageViewer} />
      )}

      <div className="info-header noselect">
        <p>
          <span>Observação</span>
          <Row>
            <div className="col input-field s12 m12 l12 xl12" style={{ padding: 0, marginTop: 0 }}>
              <textarea
                readOnly
                name="txt-observacao"
                className="materialize-textarea"
                value={observacoes}
              />
            </div>
          </Row>
        </p>
      </div>
    </ModalBox>
  );
};

export default GtoDetailsConcluded;